<app-modal [info]="info" (closeModal)="closeModal()" (onSubmit)="onExportSubmited()">
  @if (state === 'settings') {
    <div class="export">
      <div class="vacancies">
        <p class="label">
          {{ 'EXPORT.CLEVER_STAFF_EXPORT_MODAL.VACANCY_TITLE' | translate }}
        </p>
        <div class="select">
          <input
            [class.hidden]="showSearchInput"
            (click)="onSearchInputClick()"
            (input)="search()"
            (blur)="checkAndSetValidValue()"
            #searchInput
            class="search selection"
            type="text"
            [formControl]="searchControl"
            [placeholder]="placeholderForSelection | translate" />
          @if (showSearchInput) {
            <div class="selection display" (click)="switchToInput()">
              <p>{{ selectedVacancy?.position }}</p>
            </div>
          }
          <app-custom-dropdown #selectionDropdown [reference]="searchInput" [withBackdrop]="true">
            <div class="dropdown">
              <app-scrollbar
                class="scrollbar"
                [vertical]="true"
                [size]="'standard'"
                [theme]="'light'"
                [visibility]="'native'">
                @if (filteredVacancyList.length > 0) {
                  <ul class="options">
                    @for (vacancy of filteredVacancyList; track vacancy) {
                      <li
                        class="option"
                        [class.selected]="vacancy.vacancyId === selectedVacancy?.vacancyId"
                        (click)="selectOptionForSelection(vacancy)">
                        {{ vacancy.position }}
                      </li>
                    }
                  </ul>
                } @else {
                  <p class="empty">
                    {{ 'EXPORT.CLEVER_STAFF_EXPORT_MODAL.EMPTY_VACANCIES' | translate }}
                  </p>
                }
              </app-scrollbar>
            </div>
          </app-custom-dropdown>
        </div>
      </div>
      @if (dublications?.length) {
        <div class="duplicated-accounts">
          <p class="label">{{ 'EXPORT.CLEVER_STAFF_EXPORT_MODAL.FOUND_ACCOUNTS' | translate }}</p>
          <app-scrollbar
            class="scrollbar"
            [vertical]="true"
            [size]="'standard'"
            [visibility]="'active'">
            <div class="duplications">
              @for (duplication of dublications; track duplication) {
                <div class="account">
                  <div class="account__item">
                    <svg width="20" height="20" class="icon">
                      <use xlink:href="#cs-duplicate-icon"></use>
                    </svg>
                    <span class="name">
                      <a [attr.href]="duplication.url" target="_blank">
                        {{ duplication.firstName }} {{ duplication.lastName }}
                      </a>
                    </span>
                    <span class="position">{{ duplication.position }}</span>
                  </div>
                  <span class="date">
                    {{ duplication.date | date: 'dd.MM.yyyy HH:mm' }}
                  </span>
                </div>
              }
            </div>
          </app-scrollbar>
        </div>
      }
      @if (showContactSettings) {
        <div class="contacts-settings">
          <p class="label">{{ 'EXPORT.SETTINGS.SETTINGS_NAME' | translate }}</p>
          <div class="toggle">
            <app-toggle
              [settings]="toggleData"
              (onToggleItem)="toggleContactSetting()"></app-toggle>
          </div>
        </div>
      }
      <div class="links">
        <a class="link" [href]="systemPagesEnum.EXPORT" target="_blank" (click)="closeModal()">
          <svg class="icon" width="14" height="14">
            <use xlink:href="#gear-icon"></use>
          </svg>
          <span class="text">
            {{ 'EXPORT.CLEVER_STAFF_EXPORT_MODAL.EXPORT_SETTINGS_LINK' | translate }}
          </span>
        </a>
        <a
          class="link"
          [href]="systemPagesEnum.EXPORT + '?tab=history'"
          target="_blank"
          (click)="closeModal()">
          <svg class="icon" width="16" height="16">
            <use xlink:href="#stopwatch"></use>
          </svg>
          <span class="text">{{ 'EXPORT.EXPORT_MODAL.EXPORT_HISTORY_LINK' | translate }}</span>
        </a>
      </div>
    </div>
  }
  @if (state !== 'settings') {
    <div class="waiting">
      <div class="animation">
        <app-waiting-animation [state]="state"></app-waiting-animation>
        @if (progressPercentage !== null) {
          <div [class.hidden]="state !== 'waiting'" class="progress-indicator">
            {{ progressPercentage + '%' }}
          </div>
        }
      </div>
      <div class="info-text">
        <p>{{ infoText | translate }}</p>
      </div>
      <div class="links">
        <a class="link" [href]="systemPagesEnum.EXPORT + '?tab=history'" target="_blank">
          <svg class="icon" width="16" height="16">
            <use xlink:href="#stopwatch"></use>
          </svg>
          <span class="text">{{ 'EXPORT.EXPORT_MODAL.EXPORT_HISTORY_LINK' | translate }}</span>
        </a>
      </div>
    </div>
  }
</app-modal>
